import { Box, Button, Paper, TextField } from "@mui/material";
import React from "react";
import { ContainerStyle } from "../styled";

const JoinRoom = ({ inputCode, setInputCode, userName, setUserName, handleJoinRoom }) => {
    return (
        <ContainerStyle sx={{ pt: 5, textAlign: "center" }}>
            <Box sx={{ fontWeight: "bold", fontSize: "2em", color: "#1b5e20", mb: 0.5 }}>
                🎲 โดมิโน Double Nine
            </Box>
            <Box sx={{ fontSize: "0.85em", color: "#888", mb: 3 }}>เกมออนไลน์สำหรับ 2–6 คน</Box>
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    borderRadius: 4,
                    maxWidth: 460,
                    width: "100%",
                    mx: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <TextField
                    label="Room Code"
                    fullWidth
                    value={inputCode}
                    onChange={(e) => setInputCode(e.target.value)}
                    variant="outlined"
                />
                <TextField
                    label="ชื่อของคุณ"
                    fullWidth
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleJoinRoom()}
                />
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleJoinRoom}
                    sx={{ py: 1.5, borderRadius: 2, bgcolor: "#1b5e20" }}
                >
                    JOIN ROOM
                </Button>
            </Paper>
        </ContainerStyle>
    );
};

export default JoinRoom;
